import React, { useEffect } from 'react';
import { createElement } from 'react';
import Button from '../../button';
import './style.less';
function InfoCard(props) {
    const { pageData = {} } = props;
    const [content, setContent] = React.useState('');
    useEffect(() => {
        if (pageData.content) {
            setContent(window.decodeURIComponent(pageData.content));
        }
    }, [pageData]);
    return (createElement("div", { className: "info-card" },
        createElement("p", { className: "info-card-content" },
            createElement("span", { role: "text", "aria-label": pageData?.readme || '00000', dangerouslySetInnerHTML: { __html: content } })),
        pageData?.buttons.map((item, index) => (createElement("div", { key: index, className: `${item.buttonType == '3'
                ? 'info-card-button-text-container'
                : 'info-card-button-container'}` }, item.buttonType == '3' ? (createElement("a", { className: "info-card-button-text", role: "button", onClick: () => {
                handleJump(item);
            } }, item.btnName || item.titleValue)) : (createElement(Button, { className: item.buttonType == '2'
                ? 'info-card-button-secondary'
                : item.buttonType == '3'
                    ? 'info-card-button-text'
                    : 'info-card-button', key: index, title: item.btnName || item.titleValue, fixedWidth: "short", isRadius: true, onClick: () => {
            } })))))));
}
export default InfoCard;
